<template>
  <div>
    <v-alert
      v-if="scrapeRunning && isAssistedOnboardingEnabled && isOnboardingWebScrapingEnabled"
      type="info"
      variant="tonal"
      density="compact"
      rounded="lg"
      icon="mdi-web-sync"
      class="mb-6"
    >
      <span class="text-body-2">
        {{ $t('onboarding.wizard.data-entry.scrape-in-progress-hint') }}
      </span>
    </v-alert>

    <OnboardingFormField
      class="mb-6"
      field-key="slogan"
      icon="mdi-text-short"
      :label="$t('onboarding.wizard.data-entry.slogan')"
    >
      <v-text-field
        :model-value="formData.slogan"
        id="onboarding-field-slogan"
        data-ai-field="slogan"
        :class="fieldClass('slogan')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        :placeholder="$t('onboarding.wizard.data-entry.slogan-placeholder')"
        hide-details
        @focus="onFieldFocus('slogan')"
        @update:model-value="updateField('slogan', $event)"
      />
    </OnboardingFormField>

    <OnboardingFormField
      class="mb-6"
      field-key="businessDescription"
      icon="mdi-text-long"
      :label="$t('onboarding.wizard.data-entry.business-description')"
    >
      <v-textarea
        :model-value="formData.businessDescription"
        id="onboarding-field-businessDescription"
        data-ai-field="businessDescription"
        :class="fieldClass('businessDescription')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        rows="3"
        auto-grow
        :placeholder="$t('onboarding.wizard.data-entry.business-description-placeholder')"
        hide-details
        @focus="onFieldFocus('businessDescription')"
        @update:model-value="updateField('businessDescription', $event)"
      />
    </OnboardingFormField>

    <v-divider class="mb-6" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useAiAssistantStore } from '@/stores/aiAssistant'

import { useOnboardingDataEntryContext } from '../../composables/onboardingDataEntryContext'
import { useOnboardingFeatures } from '../../composables/useOnboardingFeatures'
import OnboardingFormField from './OnboardingFormField.vue'

const { formData, updateField, fieldClass, onFieldFocus } = useOnboardingDataEntryContext()
const { scrapeRunning } = storeToRefs(useAiAssistantStore())
const { isAssistedOnboardingEnabled, isOnboardingWebScrapingEnabled } = useOnboardingFeatures()
</script>
